<template>
  <div class="form-card">
    <div class="form-card__header">
      <h6 class="form-card__title">
        <i :class="salePointId == null ? 'bi bi-plus-lg' : 'bi bi-pencil'"></i>
        {{ salePointId == null ? 'Nuevo punto de venta' : 'Editar punto de venta' }}
      </h6>
      <button v-if="salePointId != null" type="button" class="form-card__btn" @click="resetForm()">
        <i class="bi bi-plus-lg"></i>
        Nuevo
      </button>
    </div>

    <div class="form-card__body">
      <form @submit.prevent>
        <div class="form-card__field">
          <label class="form-card__label" for="sp-number">Número de punto de venta</label>
          <input id="sp-number" type="number" class="form-control" v-model="salePoint.number" placeholder="Nº Ej:1"/>
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="sp-branchoffice">Sucursal</label>
          <select id="sp-branchoffice" class="form-control" v-model="salePoint.bo_id">
            <option :value="null" disabled>Seleccioná una sucursal</option>
            <option v-for="branchoffice in branchoffices" :key="branchoffice.id" :value="branchoffice.id">
              {{ branchoffice.name }}
            </option>
          </select>
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="sp-type">Tipo</label>
          <select id="sp-type" class="form-control" v-model="salePoint.type">
            <option :value="null" disabled>Seleccioná un tipo</option>
            <option value="PRUEBA">Prueba</option>
            <option value="FISCAL">Fiscal</option>
          </select>
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="sp-editable">Tipo de numeración</label>
          <select id="sp-editable" class="form-control" v-model="salePoint.editable">
            <option :value="null" disabled>Seleccioná una opción</option>
            <option value="1">Editable</option>
            <option value="0">Automática</option>
          </select>
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="sp-actived">Estado</label>
          <select id="sp-actived" class="form-control" v-model="salePoint.actived">
            <option :value="null" disabled>Seleccioná un estado</option>
            <option value="1">Habilitado</option>
            <option value="0">Deshabilitado</option>
          </select>
        </div>
      </form>
    </div>

    <div class="form-card__footer">
      <button type="button" class="form-card__btn form-card__btn--primary" :disabled="isLoading" @click="save()">
        <i class="bi bi-check-lg"></i>
        {{ salePointId ? 'Modificar' : 'Guardar' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: ['salePointId','branchoffices'],
  data: function() {
    return {
      isLoading: false,
      salePoint: {
        id:null,
        bo_id:null,
        number: null,
        type: null,
        editable: null,
        actived: null,
      },
      emptySalePoint: {
        id:null,
        bo_id:null,
        number: null,
        type: null,
        editable: null,
        actived: null,
      },

    };
  },
  watch: {
    salePointId: {
      handler: function (salePointId) {
        if(salePointId != null)
          this.getSalePoint();
        else
          this.resetForm();
      }
    }
  },  
  methods: {
    getSalePoint() {
      var vm = this;
      vm.isLoading = true
      this.$http.get("/api/configs/pos/show/" + this.salePointId).then((response) => {
        vm.salePoint = response.data.data;
        vm.isLoading = false
      });
    },
    resetForm(){
      this.salePoint =  Object.assign({}, this.emptySalePoint);
      this.$emit('saved')
    },
    save() {
      if (this.salePoint.id != null) {
        this.isLoading = true
        this.$http
          .post("/api/configs/pos/update/" + this.salePoint.id, this.salePoint)
          .then(() => {
            
            this.salePoint = this.emptySalePoint;
            this.$emit('saved');
          });
      } else {
        this.isLoading = true
        this.$http.post("/api/configs/pos/create", this.salePoint).then(() => {
          
          this.salePoint = this.emptySalePoint;
          this.$emit('saved');
        });
      }
    },
  },
};
</script>